(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function initContactFormLaunch() {
    const forms = document.querySelectorAll('#ContactForm');
    if (!forms.length) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (const form of forms) {
      const btn = form.querySelector('[data-contact-submit]');
      if (!btn) continue;
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;
        if (prefersReducedMotion) return;
        event.preventDefault();
        btn.setAttribute('data-launching', '');
        btn.disabled = true;
        setTimeout(() => { form.submit(); }, 520);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function initTestimonials() {
    const carousels = document.querySelectorAll('[data-testimonials]');
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-testimonials-track]');
      const prev = carousel.querySelector('[data-testimonials-prev]');
      const next = carousel.querySelector('[data-testimonials-next]');
      if (!track) return;

      const autoplayMs = parseInt(carousel.dataset.autoplayMs, 10) || 6000;
      const resumeDelay = 4000;

      const cardWidth = () => {
        const first = track.firstElementChild;
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return first.offsetWidth + gap;
      };

      const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      const scrollCards = (n) => track.scrollBy({ left: cardWidth() * n, behavior: 'smooth' });

      let timer;
      let paused = false;
      let resumeT;

      const advance = () => {
        if (atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollCards(1);
        }
      };

      // No auto-advance for visitors who ask for reduced motion (WCAG 2.2.2, 2.3.3).
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const start = () => {
        if (paused || reducedMotion.matches) return;
        stop();
        timer = setInterval(advance, autoplayMs);
      };

      const stop = () => {
        clearInterval(timer);
      };

      const pauseTemporarily = () => {
        paused = true;
        stop();
        clearTimeout(resumeT);
        resumeT = setTimeout(() => {
          paused = false;
          start();
        }, resumeDelay);
      };

      prev?.addEventListener('click', () => {
        scrollCards(-1);
        pauseTemporarily();
      });

      next?.addEventListener('click', () => {
        scrollCards(1);
        pauseTemporarily();
      });

      // Pause on hover (desktop)
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', () => {
        if (!paused) start();
      });

      // Hold still while a keyboard user is inside the carousel
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (e) => {
        if (!carousel.contains(e.relatedTarget) && !paused) start();
      });

      // Pause on touch/drag/wheel interactions
      track.addEventListener('pointerdown', pauseTemporarily, { passive: true });
      track.addEventListener('wheel', pauseTemporarily, { passive: true });

      // Pause when the tab is hidden
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else if (!paused) start();
      });

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
